export default "__VITE_ASSET__BzR$uDc3__"